import React from "react";
import HeaderSecundario from "../components/HeaderSecundario.js";

export default function ResultadoReserva(props) {
  return (
    <div>
      {props.resultado === 1 && (
        <div>
          <HeaderSecundario modelos={props.modelos} />
          <div className="gracias">¡Felicitaciones!</div>
          <div className="textoGracias">
            La operación concluyó con éxito. Conserve su código de compra para
            consultas: <b>{props.comprobante}</b>
          </div>
          <div className="textoGraciasSecundario">
            {" "}
            En breve recibirás un mail con los datos de tu reserva y los pasos a
            seguir.
            <br />
            <br />
            ¡Muy pronto vas a estar disfrutando tu 0KM, sin vueltas!
          </div>
        </div>
      )}

      {props.resultado === 2 && (
        <div>
          <HeaderSecundario modelos={props.modelos} />
          <div className="gracias">La Operación fue fallida</div>
          <div className="textoGracias">
            Posible causa: los datos ingresados fueron incorrectos, su tarjeta
            fue rechazada o el servicio no esta disponible en este instante.
          </div>
          <div className="textoGraciasSecundario">
            Por favor reintente en unos minutos.
          </div>
          <div className="textoGracias">
            De persistir el error, le pedimos envíe un e-mail a
            <b> clamadevelopers@gmail.com </b> para que podamos asistirlo con su
            transacción.
          </div>
        </div>
      )}
    </div>
  );
}
